import React, { useState, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import noticia1 from '../../img/Voluntariado.jpg';
// import noticia2 from '../../img/noticia2.png';
// import noticia3 from '../../img/noticia3.png';
// import noticia4 from '../../img/noticia4.png';
// import noticia5 from '../../img/noticia5.png';
// import noticia6 from '../../img/noticia6.png';
import './News.css';

function News() {
  const [noticias, setNoticias] = useState([]);
  const [noticiaSelecionada, setNoticiaSelecionada] = useState(null);
  const [dataPublicacaoFormatada, setDataPublicacaoFormatada] = useState('');

  function formatarData(dataString) {
    const data = new Date(dataString); // Cria um objeto Date
    const dia = data.getDate();
    const mes = data.getMonth() + 1; // Os meses em JavaScript são de 0 a 11
    const ano = data.getFullYear();
    const nomeMes = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][mes - 1];
    return `${dia} de ${nomeMes} de ${ano}`;
  }

  useEffect(() => {
    fetch(process.env.REACT_APP_API_NOTICIAS)
    .then(response => response.json())
      .then(data => {
        // console.log(data);
        if (data.retorno === "sucesso") {
          
         setNoticias(data.noticias);
        } else {
          console.error('Erro ao buscar notícias:', data);
        }
      })
      .catch(error => console.error('Erro ao buscar notícias:', error));
  }, []);

  const handleNoticiaClick = (noticia) => {
    setNoticiaSelecionada(noticia);

  };

  return (
    <div className="text-center" id="newsTop">
      <Row className="align-items-center">
        <Col md={6}>
          <h2 className="mb-0" id="art">Artigos</h2>
        </Col>
        <Col md={6}>
          <p className="mb-0"><a href="#" style={{cursor: 'pointer', textDecoration:'none'}}><strong id="seeAll">Ver todos</strong></a></p>
        </Col>
      </Row>
      <div className="container text-center mt-5" id='tabel'>
        <table className="table table-sm">
          <tbody>
          {noticias.map((noticia) => (
            <tr key={noticia.id}>
              <td className="col-12 col-md-6">
                <a href="/noticia1" 
                id="names" 
                className="list-group-item list-group-item-action" 
                aria-current="true"
                onClick={() => {
                  // alert(JSON.stringify(noticia))
                  localStorage.setItem('selectedNoticia', JSON.stringify(noticia));
                }}>
                  <small className="text-muted">{formatarData(noticia.data_publicacao)} </small>
                  <br />
                  <br />
                  <h5 className="mb-1">{noticia.titulo}</h5>
                  <br />
                  <p className="text-muted">{noticia.sub_titulo}</p>
                </a>
                <img id="imgNews" src={noticia.caminho_imagem} alt="coracao" className="news-image d-block d-md-none" />
              </td>
              <td className="col-12 col-md-6">
                <a href="/noticia1"  onClick={() => {localStorage.setItem('selectedNoticia', JSON.stringify(noticia));}} id="names" className="list-group-item list-group-item-action" aria-current="true">
                  <img id="imgNews" src={noticia.caminho_imagem} alt="coracao" className="news-image d-none d-md-block" />
                </a>
              </td>
            </tr> 
          ))}
            {/* <tr> */}
              {/* <td className="col-12 col-md-6">
                <a href="/noticia1" id="names" className="list-group-item list-group-item-action" aria-current="true">
                  <small className="text-muted">12 de junho, 2024  </small>
                  <br />
                  <br />
                  <h5 className="mb-1">O Poder Transformador do Voluntariado</h5>
                  <br />
                  <p className="text-muted">Descubra "O Poder Transformador do Voluntariado" e seja um agente de mudança com o Instituto Unimed!</p>
                </a>
                <img id="imgNews" src={noticia1} alt="coracao" className="news-image d-block d-md-none" />
              </td>
              <td className="col-12 col-md-6">
                <a href="/noticia1" id="names" className="list-group-item list-group-item-action" aria-current="true">
                  <img id="imgNews" src={noticia1} alt="coracao" className="news-image d-none d-md-block" />
                </a>
              </td> */}
            {/* </tr> */}
            {/* <tr>
              <td className="col-12 col-md-6">
                <a href="#" id="names" className="list-group-item list-group-item-action">
                  <small className="text-muted">AUGUST 13, 2021  </small>
                  <h5 className="mb-1">10 Hilarious Cartoons That Depict Real-Life Problems of Programmers</h5>
                  <p className="text-muted">Redefined the user acquisition and redesigned the onboarding experience, all within 3 working weeks.</p>
                </a>
                <img src={noticia2} alt="lapis" className="news-image d-block d-md-none" />
              </td>
              <td className="col-12 col-md-6">
                <img src={noticia2} alt="lapis" className="news-image d-none d-md-block" />
              </td>
            </tr>
            <tr>
              <td className="col-12 col-md-6">
                <a href="#" id="names" className="list-group-item list-group-item-action">
                  <small className="text-muted">AUGUST 13, 2021  </small>
                  <h5 className="mb-1">10 Hilarious Cartoons That Depict Real-Life Problems of Programmers</h5>
                  <p className="text-muted">Redefined the user acquisition and redesigned the onboarding experience, all within 3 working weeks.</p>
                </a>
                <img src={noticia3} alt="mao" className="news-image d-block d-md-none" />
              </td>
              <td className="col-12 col-md-6">
                <img src={noticia3} alt="mao" className="news-image d-none d-md-block" />
              </td>
            </tr> */}
          </tbody>
        </table>
      </div>
      <br /><br /><br />
      {/* <Row className="align-items-center">
        <Col md={6}>
          <h2 className="mb-0">Noticias</h2>
        </Col>
        <Col md={6}>
          <p className="mb-0"><a href="#" style={{cursor: 'pointer', textDecoration:'none'}}><strong>Ver todos</strong></a></p>
        </Col>
      </Row> */}
      {/* <div className="container text-center mt-5" id='tabel'>
        <table className="table table-sm">
          <tbody>
            <tr>
              <td className="col-12 col-md-6">
                <a href="#" id="names" className="list-group-item list-group-item-action" aria-current="true">
                  <small className="text-muted">AUGUST 13, 2021  </small>
                  <h5 className="mb-1">10 Hilarious Cartoons That Depict Real-Life Problems of Programmers</h5>
                  <p className="text-muted">Redefined the user acquisition and redesigned the onboarding experience, all within 3 working weeks.</p>
                </a>
                <img src={noticia4} alt="coracao" className="news-image d-block d-md-none" />
              </td>
              <td className="col-12 col-md-6">
                <img src={noticia4} alt="coracao" className="news-image d-none d-md-block" />
              </td>
            </tr>
            <tr>
              <td className="col-12 col-md-6">
                <a href="#" id="names" className="list-group-item list-group-item-action">
                  <small className="text-muted">AUGUST 13, 2021  </small>
                  <h5 className="mb-1">10 Hilarious Cartoons That Depict Real-Life Problems of Programmers</h5>
                  <p className="text-muted">Redefined the user acquisition and redesigned the onboarding experience, all within 3 working weeks.</p>
                </a>
                <img src={noticia5} alt="lapis" className="news-image d-block d-md-none" />
              </td>
              <td className="col-12 col-md-6">
                <img src={noticia5} alt="lapis" className="news-image d-none d-md-block" />
              </td>
            </tr>
            <tr>
              <td className="col-12 col-md-6">
                <a href="#" id="names" className="list-group-item list-group-item-action">
                  <small className="text-muted">AUGUST 13, 2021  </small>
                  <h5 className="mb-1">10 Hilarious Cartoons That Depict Real-Life Problems of Programmers</h5>
                  <p className="text-muted">Redefined the user acquisition and redesigned the onboarding experience, all within 3 working weeks.</p>
                </a>
                <img src={noticia6} alt="mao" className="news-image d-block d-md-none" />
              </td>
              <td className="col-12 col-md-6">
                <img src={noticia6} alt="mao" className="news-image d-none d-md-block" />
              </td>
            </tr>
          </tbody>
        </table>
      </div> */}
    </div>
  );
}

export default News;
